import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useI18n } from 'vue-i18n';
  
export default /*#__PURE__*/_defineComponent({
  props: {
    count: null
  },
  setup(__props: any) {

  const { t } = useI18n();
  const COUNT_TEXT = ['1st', '2nd', '3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th'];
  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    innerHTML: _unref(t)('title', { name: COUNT_TEXT[__props.count] })
  }, null, 8, _hoisted_1))
}
}

})